"use client"

import { Col, Row } from "antd"
import SelectDestination from "./SelectDestination"
import SelectDeparture from "./SelectDeparture"
import ButtonSearch from "./ButtonSearch"
import SelectDepartureDate from "./SelectRangeDate"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"
import { FC } from "react"

type FormSearchToursProps = {
  size?: 'default' | 'small',
  enabledMobile?: boolean
}

const FormSearchTours: FC<FormSearchToursProps> = ({ size = 'default', enabledMobile = true }) => {
  const isDesktop = useIsDesktop()
  const isSmall = size === 'small'

  if (!isDesktop && enabledMobile) {
    return (
      <Row gutter={[10, 10]} style={{ marginBlock: '2rem' }}>
        <Col span={24}>
          <SelectDestination />
        </Col>
        <Col span={24}>
          <Row gutter={[10, 10]}>
            <Col span={24}>
              <SelectDepartureDate />
            </Col>
            <Col span={24}>
              <SelectDeparture />
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <ButtonSearch />
        </Col>
      </Row>
    )
  }

  /* Desktop: một hàng — điểm đến | ngày | khởi hành | tìm */
  return (
    <Row
      wrap={false}
      gutter={isSmall ? [0, 0] : [12, 0]}
      align="stretch"
      className={
        isSmall
          ? 'home__searching--tour-search-row home__searching--tour-search-row--bar'
          : 'home__searching--tour-search-row'
      }
      style={isSmall ? { marginBlock: 0 } : { marginBlock: '2rem' }}
    >
      <Col
        flex="1.15 1 13rem"
        className={isSmall ? 'home__searching--tour-search-cell' : undefined}
      >
        <SelectDestination />
      </Col>
      <Col
        flex="0.9 1 10rem"
        className={isSmall ? 'home__searching--tour-search-cell' : undefined}
      >
        <SelectDepartureDate />
      </Col>
      <Col
        flex="1 1 12rem"
        className={isSmall ? 'home__searching--tour-search-cell' : undefined}
      >
        <SelectDeparture />
      </Col>
      <Col
        flex="none"
        className={
          isSmall
            ? 'home__searching--tour-search-cell home__searching--tour-search-cell--btn'
            : undefined
        }
      >
        <ButtonSearch compact />
      </Col>
    </Row>
  )
}

FormSearchTours.displayName = 'FormSearchTours'

export default FormSearchTours
